<template>
	<v-select
		v-model="selected"
		:items="accounts"
		:loading="loading"
		:label="labelText"
		item-value="id"
		outlined
		dense
		hide-details="auto"
	>
		<template #selection="{ item }">
			<div
				class="d-flex align-center"
				style="gap: 8px;"
			>
				<v-avatar
					size="24"
					color="primary"
				>
					<v-img
						v-if="item.avatar_url"
						:src="item.avatar_url"
					/>
					<span
						v-else
						class="white--text caption"
					>{{ initials(item) }}</span>
				</v-avatar>
				<span>{{ fullName(item) }}</span>
			</div>
		</template>

		<template #item="{ item }">
			<v-list-item-avatar
				size="36"
				color="primary"
				class="my-2"
			>
				<v-img
					v-if="item.avatar_url"
					:src="item.avatar_url"
				/>
				<span
					v-else
					class="white--text body-2 font-weight-medium"
				>{{ initials(item) }}</span>
			</v-list-item-avatar>
			<v-list-item-content class="py-2">
				<v-list-item-title>{{ fullName(item) }}</v-list-item-title>
				<v-list-item-subtitle v-if="item.nickname">
					@{{ item.nickname }}
				</v-list-item-subtitle>
			</v-list-item-content>
		</template>
	</v-select>
</template>

<script>
import { getNetworkAccounts } from '@/services/community/networkAccounts'

let accountsCache = null

export default {
	name: 'NetworkAccountSelect',
	props: {
		value: {
			type: [String, Number],
			default: null,
		},
		labelText: {
			type: String,
			default: 'Publish as',
		},
	},
	data() {
		return {
			accounts: [],
			loading: false,
		}
	},
	computed: {
		selected: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		},
	},
	async mounted() {
		if (accountsCache) {
			this.accounts = accountsCache
			return
		}
		this.loading = true
		try {
			const { data } = await getNetworkAccounts()
			this.accounts = data.data || []
			accountsCache = this.accounts
		} catch {
			this.accounts = []
		} finally {
			this.loading = false
		}
	},
	methods: {
		fullName(user) {
			if (!user) return ''
			return `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim()
		},
		initials(user) {
			const f = user.first_name?.[0] ?? ''
			const l = user.last_name?.[0] ?? ''
			return (f + l).toUpperCase() || '?'
		},
	},
}
</script>
